import { Outlet } from "react-router-dom";
import { adminPaymentsRoutes } from "../Payments/payments-routes";
import { adminUnpaidClientsRoutes } from "../UnpaidClients/unpaid-clients-routes";
import SubOrderForm from "./SubOrderForm";
import SubOrderDetails from "./SubOrderDetails";
import SubOrdersList from "./SubOrdersList";


export const adminSubOrdersRoutes = [
  {
    path: "sub-orders",
    element: Outlet,
    children: [
      {
        path: '',
        redirect: 'list'
      },
      {
        path: "list",
        element: SubOrdersList,
      },
      {
        path: "add",
        element: SubOrderForm,
      },
      {
        path: "edit/:id",
        element: SubOrderForm,
      },
      {
        path: "view/:id",
        element: SubOrderDetails,
      },
      ...adminPaymentsRoutes,
      ...adminUnpaidClientsRoutes
    ],
  },
];
